import * as constraintActions from '../constraint/actions';

export const ADD_CONSTRAINT = 'ADD_CONSTRAINT';
export const REMOVE_CONSTRAINT = 'REMOVE_CONSTRAINT';
export const CLEAR_CONSTRAINTS = 'CLEAR_CONSTRAINTS';

export const {
  SET_OPERATOR,
  SET_VALUE,
} = constraintActions;

export const clear = () => ({
  type: CLEAR_CONSTRAINTS,
});

export const addConstraint = constraint => ({
  type: ADD_CONSTRAINT,
  constraint,
});

export const removeConstraint = constraintIndex => ({
  type: REMOVE_CONSTRAINT,
  index: constraintIndex,
});

export const setOperator = (constraintIndex, ...args) => ({
  ...constraintActions.setOperator(...args),
  constraintIndex,
});

export const setValue = (constraintIndex, ...args) => ({
  ...constraintActions.setValue(...args),
  constraintIndex,
});
